export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8788.de03a7eb.jpg";